import { Client } from "@taruvi/sdk";

export const taruviClient = (() => {
  try {
    return new Client({
      apiKey: import.meta.env.VITE_TARUVI_API_KEY,
      appSlug: import.meta.env.VITE_TARUVI_APP_SLUG,
      apiUrl: import.meta.env.VITE_TARUVI_BASE_URL,
    });
  } catch (error) {
    console.error("Failed to initialize Taruvi Client:", error);
    throw new Error(
      "Taruvi configuration error. Please check your .env.local file. " +
      "See .env.example for required variables."
    );
  }
})();
